import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, useState } from "react";
import Tab from "./Tab";
import "./_style.scss";
const TabbedContainer = ({ children, activeIndex: controlledIndex, onTabChange, }) => {
    const tabs = Children.toArray(children).filter((child) => React.isValidElement(child)
        && child.type === Tab);
    const defaultIndex = tabs.findIndex((tab) => tab.props.isDefault);
    const [internalIndex, setInternalIndex] = useState(defaultIndex >= 0 ? defaultIndex : 0);
    const isControlled = controlledIndex !== undefined;
    const activeIndex = isControlled ? controlledIndex : internalIndex;
    const setActiveIndex = (index) => {
        if (!isControlled) {
            setInternalIndex(index);
        }
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(index);
    };
    const activeTab = tabs[activeIndex];
    return (_jsxs("div", { className: "tabbed-container", children: [_jsx("nav", { className: "tabbed-container__nav", children: _jsx("ul", { className: "tabbed-container__tab-list", children: tabs.map((tab, index) => (_jsx("li", { className: "tabbed-container__tab-item", children: _jsxs("button", { type: "button", className: [
                                "tabbed-container__tab-button",
                                activeIndex === index ? "--is-active" : "",
                                tab.props.isDisabled ? "--is-disabled" : "",
                            ].filter(Boolean).join(" "), onClick: () => setActiveIndex(index), disabled: tab.props.isDisabled, children: [tab.props.label, tab.props.count != null && (_jsx("span", { className: "tabbed-container__tab-badge", children: tab.props.count }))] }) }, tab.props.label))) }) }), _jsx("div", { className: "tabbed-container__content", children: activeTab === null || activeTab === void 0 ? void 0 : activeTab.props.children })] }));
};
TabbedContainer.Tab = Tab;
export default TabbedContainer;
